/*
  Palette: https://material.io/tools/color/
  Names: http://chir.ag/projects/name-that-color/
*/
const palette = {
  white: "#FFFFFF",
  seashell: "#F1F1F1",
  silver: "#c7c7c7",
  silverChalice: "#A7A7A7",
  gray: "#888888",
  tundora: "#484848",
  mineshaft: "#212121",
  black: "#000000",
  netEntGreenDark: "#78BE20",
  netEntGreenLight: "#7ED321",
  bittersweet: "#FF6E6E"
};

interface ITheme {
  primary: string;
  primaryDark: string;
  primaryLight: string;
  onPrimary: string;
  secondary: string;
  secondaryDark: string;
  secondaryLight: string;
  analogous: string;
  analogousLight: string;
  complementaryOnSecondary: string;
  complementaryOnPrimary: string;
  success: string;
  error: string;
  disabled: string;
}

/*
  Based on:
  https://material.io/design/color/the-color-system.html#color-theme-creation
  https://material.io/design/color/the-color-system.html#tools-for-picking-colors
*/
export const themeColors: ITheme = {
  primary: palette.mineshaft,
  primaryDark: palette.black,
  primaryLight: palette.tundora,
  onPrimary: palette.white,
  secondary: palette.seashell,
  secondaryDark: palette.silver,
  secondaryLight: palette.white,
  analogous: palette.gray,
  analogousLight: palette.silverChalice,
  complementaryOnSecondary: palette.netEntGreenDark,
  complementaryOnPrimary: palette.netEntGreenLight,
  success: palette.netEntGreenLight,
  error: palette.bittersweet,
  disabled: palette.gray
};
